import I18n from 'I18n';
import { getLanguageName } from 'FormsUI/utils/LangUtils';
import { TemplateNames } from 'FormsUI/constants/Templates';
export const getDefaultTranslatedFormName = (formName, lang) => `${formName} [${getLanguageName(lang)}]`;
export const getDefaultFormName = templateName => {
  switch (templateName) {
    case TemplateNames.BLANK:
      return I18n.text('templates.blank.defaultFormName');
    case TemplateNames.SUPPORT:
      return I18n.text('templates.support.defaultFormName');
    case TemplateNames.NEWSLETTER:
      return I18n.text('templates.newsletter.defaultFormName');
    case TemplateNames.EBOOK:
      return I18n.text('templates.ebook.defaultFormName');
    case TemplateNames.WEBINAR:
      return I18n.text('templates.webinar.defaultFormName');
    case TemplateNames.REGISTRATION:
      return I18n.text('templates.registration.defaultFormName');
    case TemplateNames.CONTACT_US:
      return I18n.text('templates.contactUs.defaultFormName');
    case TemplateNames.PAYMENT:
      return I18n.text('templates.payment.defaultFormName');
    default:
      return I18n.text('templates.blank.defaultFormName');
  }
};